/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import Loadable from 'react-loadable';
import {
    bool, string, object, shape, arrayOf, number, array, func,
} from 'prop-types';
import { getFeatureFlags } from '../../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const ProductNameRenderComponent = Loadable({
    loader: () => import(/* webpackChunkName: "ProductNameV1" */ './v1/ProductNameRender'),
    loading: () => <div />,
});
const ProductNameRenderComponentV2 = Loadable({
    loader: () => import(/* webpackChunkName: "ProductNameV2" */ './v2/ProductNameRender'),
    loading: () => <div />,
});

const ProductNameRender = ({
    selectedSku,
    product,
    isPassportBundleProduct,
    flagIsAvailableToShipNow,
    flagIsDeliveryMessageNextVariant,
    featureFlags,
    configuratorProduct,
    productUrl,
    isClubProduct,
    pricesList,
    getRetailPrice,
    getSalePrice,
    isPdpRedesignEnabled,
}) => (
    featureFlags['is-pdp-v-2-enabled'] ? (
        <ProductNameRenderComponentV2
            product={product}
            selectedSku={selectedSku}
            isPassportBundleProduct={isPassportBundleProduct}
            flagIsAvailableToShipNow={flagIsAvailableToShipNow}
            flagIsDeliveryMessageNextVariant={flagIsDeliveryMessageNextVariant}
            configuratorProduct={configuratorProduct}
            productUrl={productUrl}
            isClubProduct={isClubProduct}
            pricesList={pricesList}
            getRetailPrice={getRetailPrice}
            getSalePrice={getSalePrice}
            isPdpRedesignEnabled={isPdpRedesignEnabled}
        />
    ) : (
        <ProductNameRenderComponent
            product={product}
            selectedSku={selectedSku}
            isPassportBundleProduct={isPassportBundleProduct || {}}
            flagIsAvailableToShipNow={flagIsAvailableToShipNow}
            flagIsDeliveryMessageNextVariant={flagIsDeliveryMessageNextVariant}
            configuratorProduct={configuratorProduct}
            productUrl={productUrl}
            isClubProduct={isClubProduct}
            getRetailPrice={getRetailPrice}
            getSalePrice={getSalePrice}
            isPdpRedesignEnabled={isPdpRedesignEnabled}
        />
    )
);

ProductNameRender.propTypes = {

    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }).isRequired,
    product: shape({
        name: string.isRequired,
        partNumber: string.isRequired,
        shortDescription: string.isRequired,
        image: shape({
            name: string.isRequired,
            path: string.isRequired,
        }).isRequired,
        availability: shape({
            deliveryMessage: string.isRequired,
            productDeliveryType: string.isRequired,
        }).isRequired,
    }).isRequired,
    isPassportBundleProduct: shape({
        prices: {
            value: number,
        },
        enable: bool,
    }),
    flagIsAvailableToShipNow: bool,
    flagIsDeliveryMessageNextVariant: bool,
    featureFlags: object.isRequired,
    configuratorProduct: bool,
    productUrl: string,
    isClubProduct: bool,
    pricesList: array,
    getSalePrice: func,
    getRetailPrice: func,
    isPdpRedesignEnabled: bool,
};

ProductNameRender.defaultProps = {
    isPassportBundleProduct: {},
    flagIsAvailableToShipNow: false,
    flagIsDeliveryMessageNextVariant: false,
    configuratorProduct: false,
    productUrl: '',
    isClubProduct: false,
    pricesList: [],
    getSalePrice: () => {},
    getRetailPrice: () => {},
    isPdpRedesignEnabled: false,
};

const mapStateToProps = (state) => ({
    featureFlags: getFeatureFlags(state),
});

export default connect(mapStateToProps, null)(ProductNameRender);
